export let BUILD_TIME = "n/a";
export let BUILD_NUMBER = "n/a";
export let VERSION_NUMBER = "n/a";


// Called by the runtime.
export function _register(b, bn, v) {
    BUILD_TIME = b;
    BUILD_NUMBER = bn;
    VERSION_NUMBER = v;
}
